import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import { useAccount } from 'wagmi';
import { useAuthStore } from '@/store/authStore';

function App() {
  const { address, isConnected } = useAccount();
  const { checkAuth, logout } = useAuthStore();

  // Check authentication when wallet changes
  useEffect(() => {
    if (isConnected && address) {
      checkAuth(address);
    } else {
      logout();
    }
  }, [address, isConnected, checkAuth, logout]);

  return <Outlet />;
}

export default App; 